import e, { useMemo as d, useEffect as S } from "react";
import t from "./index208.mjs";
import { Description as r } from "./index209.mjs";
import { Header as N } from "./index89.mjs";
import { useAlert as k } from "./index119.mjs";
import { useSalesTermsShow as w, useTermsAndConditionsShow as y } from "./index102.mjs";
import { useSelectedRate as I } from "./index154.mjs";
import "jotai";
import "@amenitiz/design-system";
import { getConfigPropertyAtomCreator as v, ConfigProperty as A, ViewLayout as u } from "./index13.mjs";
import { setBookingSummaryShowAtom as C, createDefaultBookingSummaryShowAtom as h } from "./index25.mjs";
import { useSetAtom as L, useAtomValue as f } from "jotai/index";
import F from "classnames";
const q = ({
  salesTerms: n,
  title: g,
  checkoutStep: o = !1,
  termsAndConditions: a
}) => {
  const { setSelectedRate: _ } = I(), { setShowSalesTerms: E } = w(), { setShowTermsAndConditions: p } = y(), i = L(C), l = f(
    d(() => v(A.VIEW_LAYOUT), [])
  ), m = f(
    d(() => h(), [])
  ), b = k();
  S(() => (i(!o), () => {
    i(m);
  }), [m, i, o]);
  const s = () => {
    o ? a ? p(!1) : E(!1) : _(null);
  }, c = /* @__PURE__ */ e.createElement(
    "div",
    {
      className: F(t["terms-and-conditions"], {
        [t["terms-and-conditions-modal"]]: l === u.FULL_SCREEN
      }),
      "data-testid": "sales-terms-and-conditions"
    },
    /* @__PURE__ */ e.createElement("div", { className: t.title }, g || n.name),
    /* @__PURE__ */ e.createElement("div", { className: t.description }, /* @__PURE__ */ e.createElement(
      r,
      {
        text: a || n.booking_terms || ""
      }
    )),
    a ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.title }, I18n.t("booking_engine.results.rate.modifiable"), ":", " ", n.modifiable ? /* @__PURE__ */ e.createElement("span", { className: t.normal }, I18n.t("booking_engine.room.answer_yes")) : /* @__PURE__ */ e.createElement("span", { className: t.normal }, I18n.t("booking_engine.room.answer_no"))), n.modifiable ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.title }, I18n.t("booking_engine.results.rate.modification_terms"), ":"), /* @__PURE__ */ e.createElement("div", { className: t.description }, n.modification_terms ? /* @__PURE__ */ e.createElement(r, { text: n.modification_terms }) : null)) : null, /* @__PURE__ */ e.createElement("div", { className: t.title }, I18n.t("booking_engine.results.rate.cancellable"), ":", " ", n.cancellable ? /* @__PURE__ */ e.createElement("span", { className: t.normal }, I18n.t("booking_engine.room.answer_yes")) : /* @__PURE__ */ e.createElement("span", { className: t.normal }, I18n.t("booking_engine.room.answer_no"))), n.cancellable ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.title }, I18n.t("booking_engine.results.rate.cancellation_terms"), ":"), /* @__PURE__ */ e.createElement("div", { className: t.description }, n.cancellation_terms ? /* @__PURE__ */ e.createElement(r, { text: n.cancellation_terms }) : null)) : null)
  );
  return l === u.FULL_SCREEN ? (b({
    title: I18n.t("booking_engine.information.terms_and_conditions"),
    onClose: s,
    children: c
  }), null) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    N,
    {
      title: I18n.t("booking_engine.information.terms_and_conditions"),
      onBack: s
    }
  ), c);
};
export {
  q as TermsAndConditions
};
